import React, { useMemo } from 'react';
import { FormattedMessage } from 'react-intl/dist';

import { POPOVER_CONFIGS } from '../../../../constants/gaep/PopoverContentGAEP';

import OverlayTrigger from 'react-bootstrap/OverlayTrigger';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faQuestionCircle, faTimes } from '@fortawesome/free-solid-svg-icons';

import { PopoverStyled, StyledEdeLevel, AffiliationTriggerContainer, PopoverHeaderCloseIcon } from './AffiliationPopover.styles';

const getPopupOverlay = (edeLevel) => {
    const { type, desc, content,  } = POPOVER_CONFIGS[edeLevel];

    return (
        <PopoverStyled>
            <PopoverStyled.Header as="h3">
                <FontAwesomeIcon icon={faQuestionCircle}/>
                <FormattedMessage id={type}/>
                <PopoverHeaderCloseIcon className='fa-solid'  icon={faTimes} onClick={() => document.body.click()} />
            </PopoverStyled.Header>
            <PopoverStyled.Body>
                <StyledEdeLevel>
                    <FormattedMessage id={desc}/>
                    <p/>
                    {
                        content.map(item => (
                            <li key={item}>
                                <FormattedMessage id={item}/>
                            </li>
                        ))
                    }
                </StyledEdeLevel>
            </PopoverStyled.Body>
        </PopoverStyled>
    );
};

const AffiliationPopover = ({ edeLevel }) => {
    const OVERLAY_DATA = useMemo(() => getPopupOverlay(edeLevel), [edeLevel]);
    const type = POPOVER_CONFIGS[edeLevel].type;

    return (
        <AffiliationTriggerContainer>
            <OverlayTrigger trigger={['hover', 'click']} placement="bottom" overlay={OVERLAY_DATA} rootClose>
                <div>
                    <a href='#'> <FormattedMessage id='gaep.popover.overlay_trigger' values={{ type: <FormattedMessage id={type}/> }}/></a>
                    <FontAwesomeIcon className='fa-solid'  icon={faQuestionCircle} />
                </div>
            </OverlayTrigger>
        </AffiliationTriggerContainer>
    );
};

export default AffiliationPopover;